import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Logo } from '../../components/Navbar';

const plans = [
  { key: 'pack_one',      name: 'Pack One',      usd: 99,  usd_q: 267, usd_y: 950,  inr: 5200,  inr_q: 14040, inr_y: 49920, agents: '2 Agents',       chats: '2,000/mo',  websites: '5',  popular: false, ai: false },
  { key: 'pack_two',      name: 'Pack Two',      usd: 149, usd_q: 402, usd_y: 1430, inr: 7499,  inr_q: 20247, inr_y: 71990, agents: '5 Agents',       chats: '20,000/mo', websites: '10', popular: true,  ai: false },
  { key: 'pack_advanced', name: 'Pack Advanced', usd: 299, usd_q: 807, usd_y: 2870, inr: 11999, inr_q: 32397, inr_y: 115190, agents: '20 Agents + AI', chats: 'Unlimited', websites: '∞',  popular: false, ai: true  },
];

export default function RegisterPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    company_name: '', owner_name: '', email: '', phone: '',
    address: '', gstin: '', state: '',
    password: '', confirm_password: '',
    plan_key: 'pack_one', billing_cycle: 'monthly', currency: (Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Kolkata' || Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta' || navigator.language === 'en-IN') ? 'inr' : 'usd'
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const getPrice = (plan) => {
    const { currency, billing_cycle } = form;
    if (currency === 'usd') {
      if (billing_cycle === 'quarterly') return '$' + plan.usd_q;
      if (billing_cycle === 'yearly') return '$' + plan.usd_y;
      return '$' + plan.usd;
    } else {
      if (billing_cycle === 'quarterly') return '₹' + plan.inr_q.toLocaleString('en-IN');
      if (billing_cycle === 'yearly') return '₹' + plan.inr_y.toLocaleString('en-IN');
      return '₹' + plan.inr.toLocaleString('en-IN');
    }
  };

  const getPeriod = () => {
    if (form.billing_cycle === 'quarterly') return '/3 months';
    if (form.billing_cycle === 'yearly') return '/year';
    return '/month';
  };

  const handleRegister = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/register', {
        company_name: form.company_name,
        owner_name: form.owner_name,
        email: form.email,
        phone: form.phone,
        address: form.address,
        state: form.state,
        gstin: form.gstin,
        password: form.password,
        plan_key: form.plan_key,
        billing_cycle: form.billing_cycle,
        currency: form.currency
      });

      if (data.success) {
        toast.success('Account created! Complete payment to activate.');
        // Save all info in sessionStorage for payment page
        sessionStorage.setItem('pay_email', form.email);
        sessionStorage.setItem('pay_password', form.password);
        sessionStorage.setItem('pay_company', form.company_name);
        sessionStorage.setItem('pay_plan', form.plan_key);
        sessionStorage.setItem('pay_currency', form.currency);
        sessionStorage.setItem('pay_cycle', form.billing_cycle);
        sessionStorage.setItem('pay_business_id', data.data.business_id);
        sessionStorage.setItem('pay_address', form.address);
        sessionStorage.setItem('pay_state', form.state);
        sessionStorage.setItem('pay_gstin', form.gstin || '');
        navigate('/payment');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#000', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ marginBottom: 28 }}><Logo /></div>

      <div style={{ width: '100%', maxWidth: 560, background: '#0d0d0d', border: '1px solid #1e1e1e', borderRadius: 16, overflow: 'hidden' }}>

        {/* Step indicator */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', background: '#111', borderBottom: '1px solid #1e1e1e' }}>
          {[['1', 'Your Details'], ['2', 'Choose Plan']].map(([n, label], i) => (
            <div key={n} style={{ padding: '13px', textAlign: 'center', borderBottom: `2px solid ${step === i + 1 ? '#00d55b' : '#1e1e1e'}`, color: step === i + 1 ? '#00d55b' : '#555', fontSize: 13, fontWeight: step === i + 1 ? 600 : 400 }}>
              {n}. {label}
            </div>
          ))}
        </div>

        <div style={{ padding: 28 }}>

          {/* Step 1 */}
          {step === 1 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <h2 style={{ fontSize: 20, fontWeight: 700 }}>Create your account</h2>
                <p style={{ color: '#555', fontSize: 13, marginTop: 4 }}>Fill in your business details to get started</p>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Company Name *</label>
                  <input value={form.company_name} onChange={e => set('company_name', e.target.value)} placeholder="Your Company" />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Owner Name *</label>
                  <input value={form.owner_name} onChange={e => set('owner_name', e.target.value)} placeholder="Your Name" />
                </div>
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Email Address *</label>
                <input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@company.com" />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Phone Number *</label>
                <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+91 99999 99999" />
              </div>
              <div>
                <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Business Address *</label>
                <input value={form.address} onChange={e => set('address', e.target.value)} placeholder="123, Street, City, State - Pincode" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>State *</label>
                  <select value={form.state} onChange={e => set('state', e.target.value)} style={{ width: '100%' }}>
                    <option value="">Select State</option>
                    <option value="Tamil Nadu">Tamil Nadu</option>
                    <option value="Andhra Pradesh">Andhra Pradesh</option>
                    <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                    <option value="Assam">Assam</option>
                    <option value="Bihar">Bihar</option>
                    <option value="Chhattisgarh">Chhattisgarh</option>
                    <option value="Goa">Goa</option>
                    <option value="Gujarat">Gujarat</option>
                    <option value="Haryana">Haryana</option>
                    <option value="Himachal Pradesh">Himachal Pradesh</option>
                    <option value="Jharkhand">Jharkhand</option>
                    <option value="Karnataka">Karnataka</option>
                    <option value="Kerala">Kerala</option>
                    <option value="Madhya Pradesh">Madhya Pradesh</option>
                    <option value="Maharashtra">Maharashtra</option>
                    <option value="Manipur">Manipur</option>
                    <option value="Meghalaya">Meghalaya</option>
                    <option value="Mizoram">Mizoram</option>
                    <option value="Nagaland">Nagaland</option>
                    <option value="Odisha">Odisha</option>
                    <option value="Punjab">Punjab</option>
                    <option value="Rajasthan">Rajasthan</option>
                    <option value="Sikkim">Sikkim</option>
                    <option value="Telangana">Telangana</option>
                    <option value="Tripura">Tripura</option>
                    <option value="Uttar Pradesh">Uttar Pradesh</option>
                    <option value="Uttarakhand">Uttarakhand</option>
                    <option value="West Bengal">West Bengal</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>GSTIN <span style={{ color: '#555', fontSize: 11 }}>(optional)</span></label>
                  <input value={form.gstin} onChange={e => set('gstin', e.target.value.toUpperCase())} placeholder="e.g. 33XXXXXXXXXXXXX" maxLength={15} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Password *</label>
                  <input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="Min 8 characters" />
                </div>
                <div>
                  <label style={{ fontSize: 12, color: '#888', display: 'block', marginBottom: 5 }}>Confirm Password *</label>
                  <input type="password" value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)} placeholder="Repeat password" />
                </div>
              </div>
              <button onClick={() => {
                if (!form.company_name || !form.owner_name || !form.email || !form.phone || !form.address || !form.state || !form.password || !form.confirm_password)
                  return toast.error('Please fill all required fields');
                if (form.password !== form.confirm_password)
                  return toast.error('Passwords do not match');
                if (form.password.length < 8)
                  return toast.error('Password must be at least 8 characters');
                setStep(2);
              }} style={{ padding: '12px', background: '#00d55b', color: '#000', borderRadius: 8, fontWeight: 700, fontSize: 15, border: 'none', cursor: 'pointer', marginTop: 4 }}>
                Continue →
              </button>
            </div>
          )}

          {/* Step 2 */}
          {step === 2 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <h2 style={{ fontSize: 20, fontWeight: 700 }}>Choose your plan</h2>
                <p style={{ color: '#555', fontSize: 13, marginTop: 4 }}>You can upgrade anytime after registration</p>
              </div>



              {/* Billing Cycle */}
              <div style={{ display: 'flex', gap: 8 }}>
                {[['monthly', 'Monthly', null], ['quarterly', 'Quarterly', 'Save 10%'], ['yearly', 'Yearly', 'Save 20%']].map(([b, l, badge]) => (
                  <button key={b} onClick={() => set('billing_cycle', b)} style={{ flex: 1, padding: '8px 4px', border: `1px solid ${form.billing_cycle === b ? '#00d55b' : '#1e1e1e'}`, background: form.billing_cycle === b ? 'rgba(0,213,91,0.1)' : '#111', color: form.billing_cycle === b ? '#00d55b' : '#888', borderRadius: 8, fontSize: 12, cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <span>{l}</span>
                    {badge && <span style={{ fontSize: 10, color: '#00d55b', fontWeight: 700 }}>{badge}</span>}
                  </button>
                ))}
              </div>

              {plans.map(p => (
                <div key={p.key} onClick={() => set('plan_key', p.key)}
                  style={{ border: `1px solid ${form.plan_key === p.key ? '#00d55b' : '#1e1e1e'}`, background: form.plan_key === p.key ? 'rgba(0,213,91,0.05)' : '#111', borderRadius: 10, padding: '14px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                      <span style={{ fontWeight: 600, fontSize: 14, color: form.plan_key === p.key ? '#00d55b' : '#fff' }}>{p.name}</span>
                      {p.popular && <span style={{ background: '#00d55b', color: '#000', fontSize: 10, padding: '1px 8px', borderRadius: 10, fontWeight: 700 }}>Popular</span>}
                      {p.ai && <span style={{ background: 'rgba(0,213,91,0.15)', color: '#00d55b', fontSize: 10, padding: '1px 8px', borderRadius: 10 }}>AI</span>}
                    </div>
                    <div style={{ color: '#555', fontSize: 12 }}>{p.agents} · {p.chats}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#00d55b' }}>
                      {getPrice(p)}
                    </div>
                    <div style={{ fontSize: 11, color: '#555' }}>
                      {getPeriod()}
                    </div>
                    {form.billing_cycle !== 'monthly' && (
                      <div style={{ fontSize: 10, color: '#00d55b', fontWeight: 700 }}>
                        {form.billing_cycle === 'quarterly' ? 'Save 10%' : 'Save 20%'}
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                <button onClick={() => setStep(1)} style={{ flex: 1, padding: '12px', background: '#111', border: '1px solid #1e1e1e', color: '#fff', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>← Back</button>
                <button onClick={handleRegister} disabled={loading} style={{ flex: 2, padding: '12px', background: '#00d55b', color: '#000', borderRadius: 8, fontWeight: 700, fontSize: 15, border: 'none', cursor: 'pointer', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Creating Account...' : 'Create Account →'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <p style={{ color: '#333', fontSize: 13, marginTop: 20 }}>
        Already have an account? <Link to="/login" style={{ color: '#00d55b' }}>Login here</Link>
      </p>
    </div>
  );
}